import { URL } from '../constants';
import { opsApiInstance } from '../instance';

import { EmployeeDocument, EmployeeDocumentUrl } from './types';

export type { EmployeeDocument, EmployeeDocumentUrl } from './types';

/**
 * A 5-minute signed URL for an employee's W-9 or contract. OPS answers only
 * the employee themself, Company Owner / Administrative / Accounting of the
 * same company and Site Admin; the files themselves are private.
 */
export const getEmployeeDocumentUrl = (
  employeeId: number,
  document: EmployeeDocument
) =>
  opsApiInstance.get<EmployeeDocumentUrl>(URL.UPLOAD_FILE, {
    params: { document, employeeId },
    // A missing document is a normal answer here, not a reason to leave the
    // page for the 404 screen.
    headers: { 'allow-not-found': 'true' },
  });
